import {Component, inject} from '@angular/core';
import {AnimationOptions, LottieComponent} from 'ngx-lottie';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-profile-completed',
  imports: [
    LottieComponent
  ],
  templateUrl: './profile-completed.html',
  styleUrl: './profile-completed.css',
})
export class ProfileCompleted extends AppBaseComponent {
  dialogRef = inject(DynamicDialogRef);
  options: AnimationOptions = {
    path: 'lottie/tick.json',
    autoplay: true,
  };

  close() {
    this.dialogRef.close();
    this.router.navigate(['/suggestions']);
  }
}
